module.exports = __webpack_public_path__ + "img/bg_5@2x.b54bb678.png";